import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
interface PricingCardProps {
  title: string;
  subtitle: string;
  price: string;
  popular: boolean;
  features: string[];
  iconSrc: string;
  iconAlt: string;
  ctaText: string;
  onClick: () => void;
}
export function PricingCard({
  title,
  subtitle,
  price,
  popular,
  features,
  ctaText,
  onClick
}: PricingCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} whileHover={{
    y: -4
  }} className={`relative rounded-[18px] overflow-hidden border border-[#C6A34F] transition-all duration-300 ${popular ? 'shadow-[0_4px_12px_rgba(13,195,220,0.15)] hover:shadow-[0_8px_20px_rgba(13,195,220,0.25)]' : 'shadow-md hover:shadow-[0_4px_12px_rgba(13,195,220,0.15)]'}`} style={{
    boxShadow: popular ? '0 4px 12px rgba(13, 195, 220, 0.15)' : '0 4px 12px rgba(0, 0, 0, 0.06)'
  }} data-id="element-1174">
      {popular && <div className="absolute top-0 left-0 right-0 bg-[#0DC3DC] text-white text-center py-2 text-sm font-bold relative overflow-hidden" data-id="element-1175">
          <div className="absolute inset-0 animate-pulse-glow" data-id="element-1176" />
          <span className="relative z-10" data-id="element-1177">MOST POPULAR</span>
        </div>}
      <div className={`p-6 ${popular ? 'pt-12' : ''} bg-[#212C34]`} style={{
      padding: '24px',
      paddingTop: popular ? '48px' : '24px'
    }} data-id="element-1178">
        <div className="mb-6" data-id="element-1179">
          <h3 className="text-[22px] font-bold text-white mb-1" style={{
          fontFamily: 'Poppins, sans-serif'
        }} data-id="element-1180">
            {title}
          </h3>
          <p className="text-[14px] text-[#B0B0B0]" style={{
          fontFamily: 'Poppins, sans-serif'
        }} data-id="element-1181">
            {subtitle}
          </p>
        </div>
        <div className="mb-6" data-id="element-1182">
          <span className="text-[34px] font-bold text-[#0DC3DC]" style={{
          fontFamily: 'Poppins, sans-serif'
        }} data-id="element-1183">
            {price}
          </span>
          <span className="text-white/70 ml-2 text-sm" style={{
          fontFamily: 'Poppins, sans-serif'
        }} data-id="element-1184">
            (Inc VAT)
          </span>
        </div>
        <ul className="space-y-3 mb-6" style={{
        lineHeight: '1.6'
      }} data-id="element-1185">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-1186">
              <CheckIcon size={18} className="text-[#0DC3DC] mr-2 mt-0.5 flex-shrink-0" data-id="element-1187" />
              <span className="text-white" style={{
            fontFamily: 'Poppins, sans-serif'
          }} data-id="element-1188">
                {feature}
              </span>
            </li>)}
        </ul>
        <button onClick={onClick} className={`w-full py-3 px-6 rounded-lg font-medium transition-all duration-300 ${popular ? 'bg-[#0DC3DC] hover:bg-[#0DC3DC]/90 text-white' : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'}`} style={{
        fontFamily: 'Poppins, sans-serif'
      }} data-id="element-1189">
          {ctaText}
        </button>
      </div>
      <style jsx data-id="element-1190">{`
        @keyframes pulse-glow {
          0%,
          100% {
            background: rgba(13, 195, 220, 0);
          }
          50% {
            background: rgba(13, 195, 220, 0.35);
          }
        }
        .animate-pulse-glow {
          animation: pulse-glow 3s ease-in-out infinite;
        }
      `}</style>
    </motion.div>;
}